import { Component, Injector, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { MomentFormatPipe } from "@shared/utils/moment-format.pipe";
import { CalendarModule } from 'primeng/calendar';

@Component({
    selector: 'dateCalendar',
    templateUrl: './date-calendar.component.html',
    animations: [appModuleAnimation()],
    providers: [MomentFormatPipe]
})
export class DateCalendarComponent extends AppComponentBase implements OnInit {

    @Input() dateStringInput: string;
    @Output() dateStringInputChange: EventEmitter<any> = new EventEmitter();
    @Input() styleClass?: string;
    @Input() inputStyleClass?: string;

    inputDate: Date;
    currentYear: number;

    constructor(
        injector: Injector,
        private _momentFormatPipe: MomentFormatPipe
    ) {
        super(injector);
    }

    ngOnInit() {
        this.currentYear = new Date().getFullYear();
        this.inputDate = new Date(this.dateStringInput + ", " + this.currentYear);
    }

    getYearRange(): string {
        return this.currentYear + ":" + this.currentYear;
    }

    emitOutput() {
        this.dateStringInput = this._momentFormatPipe.transform(this.inputDate.toString(), "MMMM D");
        this.dateStringInputChange.emit(this.dateStringInput);
    }
}
